/* MAGIJOUETS – photo helper window.mjLookPhotos (snippets/mj-hint).
   v17 (2026-10-10, speed): moved from the inline <script> of snippets/mj-hint.liquid, which now loads this file with defer at
   the same place. The browser and Shopify's CDN keep it in cache, so it is no longer downloaded again inside every page.
   Asset files cannot hold Liquid. */
(function () {
  if (window.mjLookPhotos) return;
  var PHOTOS = '.mj-card__well img, .mj-tile img, [data-mj-photo] img, img[data-mj-photo]';
  // look at the photo's outer edge: a white or see-through edge melts into the well, anything else is a photo
  function edge(img) {
    var s = 20, c = document.createElement('canvas'); c.width = c.height = s;
    var x = c.getContext('2d'); x.drawImage(img, 0, 0, s, s);
    var d = x.getImageData(0, 0, s, s).data, all = 0, light = 0;
    for (var r = 0; r < s; r++) for (var k = 0; k < s; k++) {
      if (r > 1 && r < s - 2 && k > 1 && k < s - 2) continue;
      var i = (r * s + k) * 4; all++;
      if (d[i + 3] < 50 || (d[i] > 226 && d[i + 1] > 226 && d[i + 2] > 226)) light++;
    }
    return light / all;
  }
  function mark(img, share) {
    if (share >= 0.45) return;
    var r = img.naturalWidth / (img.naturalHeight || 1);
    if (r >= 0.9 && r <= 1.1) img.classList.add('is-sq');
    img.classList.add('is-photo');
    if (img.classList.contains('mj-card__alt')) return; // the hover photo: its box follows the main photo
    var box = img.matches('[data-mj-photo]') ? img : img.closest('[data-mj-photo], .mj-card__well, .mj-tile');
    if (box) box.classList.add('has-photo');
  }
  function look(img) {
    if (img.__mjLook) return;
    if (!img.complete || !img.naturalWidth) {
      if (!img.__mjWait) { img.__mjWait = true; img.addEventListener('load', function () { img.__mjWait = false; look(img); }, { once: true }); }
      return;
    }
    img.__mjLook = true;
    try { mark(img, edge(img)); } catch (err) {
      // a photo from another domain cannot be read directly: read a tiny copy of it instead
      var u = img.currentSrc || img.src; if (!u || u.indexOf('data:') === 0) return;
      u = /[?&]width=\d+/.test(u) ? u.replace(/([?&]width=)\d+/, function (m, a) { return a + '40'; }) : u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=40';
      var t = new Image(); t.crossOrigin = 'anonymous';
      t.onload = function () { try { mark(img, edge(t)); } catch (e2) {} };
      t.src = u;
    }
  }
  window.mjLookPhotos = function (scope) {
    var s = scope && scope.querySelectorAll ? scope : document;
    [].forEach.call(s.querySelectorAll(PHOTOS), look);
    if (s.matches && s.matches(PHOTOS)) look(s);
  };
  // v7 sliders called this to get a hint pill; v8 shows none
  window.mjArmSwipe = function () {};

  function init() { window.mjLookPhotos(document); }
  // v17: as a deferred file this runs once the page is parsed but before DOMContentLoaded: it still waits for that event, as the inline script did
  if ((document.readyState === 'loading' || (document.readyState === 'interactive' && !(window.performance && performance.timing && performance.timing.domContentLoadedEventStart)))) document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { window.mjLookPhotos(e.target); });
  // products added later (filters, "Voir plus", recommendations): new photos are checked as they arrive
  if ('MutationObserver' in window) {
    var q = false;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) if (muts[i].addedNodes && muts[i].addedNodes.length) {
        if (!q) { q = true; setTimeout(function () { q = false; window.mjLookPhotos(document); }, 120); }
        return;
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
